"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getSigningKeySignature = exports.getAddressByProvider = exports.safeSend = exports.encodeRpcMessage = void 0;
var types_1 = require("./types");
var bs58_1 = __importDefault(require("bs58"));
var bytes_1 = require("@ethersproject/bytes");
var strings_1 = require("@ethersproject/strings");
var encodeRpcMessage = function (method, params) {
    return {
        jsonrpc: '2.0',
        id: 1,
        method: method,
        params: params,
    };
};
exports.encodeRpcMessage = encodeRpcMessage;
var safeSend = function (provider, method, params) {
    if (params == null) {
        params = [];
    }
    if (provider.request) {
        return provider.request({ method: method, params: params }).then(function (response) { return response; }, function (error) {
            throw error;
        });
    }
    else if (provider.sendAsync || provider.send) {
        var sendFunc_1 = (provider.sendAsync ? provider.sendAsync : provider.send).bind(provider);
        var request_1 = (0, exports.encodeRpcMessage)(method, params);
        return new Promise(function (resolve, reject) {
            sendFunc_1(request_1, function (error, response) {
                if (error)
                    reject(error);
                if (response.error) {
                    var error_1 = new Error(response.error.message);
                    error_1.code = response.error.code;
                    error_1.data = response.error.data;
                    reject(error_1);
                }
                resolve(response.result);
            });
        });
    }
    else {
        throw new Error("Unsupported provider; provider must implement one of the following methods: send, sendAsync, request");
    }
};
exports.safeSend = safeSend;
var getAddressByProvider = function (provider, chain) { return __awaiter(void 0, void 0, void 0, function () {
    var _a, signer, address, addresses;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0:
                _a = chain;
                switch (_a) {
                    case types_1.Blockchain.ETH: return [3 /*break*/, 1];
                    case types_1.Blockchain.SOLANA: return [3 /*break*/, 5];
                }
                return [3 /*break*/, 6];
            case 1:
                if (!(typeof provider.getSigner === 'function')) return [3 /*break*/, 3];
                signer = provider.getSigner();
                return [4 /*yield*/, signer.getAddress()];
            case 2:
                address = _b.sent();
                return [2 /*return*/, address];
            case 3: return [4 /*yield*/, (0, exports.safeSend)(provider, 'eth_accounts')];
            case 4:
                addresses = _b.sent();
                if (addresses && addresses[0]) {
                    return [2 /*return*/, addresses[0]];
                }
                else {
                    return [2 /*return*/, ''];
                }
                _b.label = 5;
            case 5:
                {
                    return [2 /*return*/, provider.publicKey.toString()];
                }
                _b.label = 6;
            case 6:
                {
                    return [2 /*return*/, ''];
                }
                _b.label = 7;
            case 7: return [2 /*return*/];
        }
    });
}); };
exports.getAddressByProvider = getAddressByProvider;
var getSigningKeySignature = function (provider, chain, message, address) { return __awaiter(void 0, void 0, void 0, function () {
    var signer, signingKeySignature_1, signingKeySignature, signingKeySignature, _a, _b;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0:
                if (!(chain === types_1.Blockchain.ETH)) return [3 /*break*/, 4];
                if (provider.isAuthereum) {
                    return [2 /*return*/, provider.signMessageWithSigningKey(message)];
                }
                if (!(typeof provider.getSigner === 'function')) return [3 /*break*/, 2];
                signer = provider.getSigner();
                return [4 /*yield*/, signer.signMessage(message)];
            case 1:
                signingKeySignature_1 = _c.sent();
                return [2 /*return*/, signingKeySignature_1];
            case 2: return [4 /*yield*/, (0, exports.safeSend)(provider, 'personal_sign', [
                    (0, bytes_1.hexlify)((0, strings_1.toUtf8Bytes)(message)),
                    address,
                ])];
            case 3:
                signingKeySignature = _c.sent();
                return [2 /*return*/, signingKeySignature];
            case 4:
                if (!(chain === types_1.Blockchain.SOLANA)) return [3 /*break*/, 6];
                _b = (_a = bs58_1.default).encode;
                return [4 /*yield*/, provider.signMessage(new TextEncoder().encode(message))];
            case 5:
                signingKeySignature = _b.apply(_a, [_c.sent()]);
                return [2 /*return*/, signingKeySignature];
            case 6: return [2 /*return*/, ''];
        }
    });
}); };
exports.getSigningKeySignature = getSigningKeySignature;
//# sourceMappingURL=utils.js.map